import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79598ae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-box" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "nav" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-79598ae0><div class=\"info-item\" data-v-79598ae0><p class=\"item-title\" data-v-79598ae0>合作协议</p><p class=\"item-desc\" data-v-79598ae0> 1、个人会员优惠于单次购买商品的价格，企业会员折扣优惠力度更大 </p><p class=\"item-desc\" data-v-79598ae0>2、个人与企业合作方式包括：</p><p class=\"item-desc\" data-v-79598ae0>   （1）直接购买平台商品，不提供作品上传 </p><p class=\"item-desc\" data-v-79598ae0>  （2）购买且提供作品上传</p><p class=\"item-desc\" data-v-79598ae0>   （3）不购买平台商品，但具有输出上传的作品可直接被买断 </p><p class=\"item-desc\" data-v-79598ae0> 3、企业账号为母帐号，根据购买金额，每个母账号下可有1-10个不等的子账号，子帐号共享母帐号下载的权限，账号金额消费完后如果续费，可享受9.8折的优惠 </p><p class=\"item-desc\" data-v-79598ae0> 4、企业母帐号具有管理及充值权限，子帐号只有消费权限 </p><p class=\"item-desc\" data-v-79598ae0> 5、企业所提供的作品平台审核后，对于可用予以发布的，并后台记录数量，不合规格文件返至企业修改，直至完成格式要求或退回； </p><p class=\"item-desc\" data-v-79598ae0>6、对于大型供应商合作可签署线下合同</p><p class=\"item-desc\" data-v-79598ae0> 7、供应商合作前还需要平台资质审核，审核通过即可进行合作 </p><p class=\"item-desc\" data-v-79598ae0>8、以上内容最终解释权归本网站</p></div><div class=\"info-item\" data-v-79598ae0><p class=\"item-title\" data-v-79598ae0>合作流程</p><img src=\"/static/info/20211007094426.jpg\" data-v-79598ae0></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 用户指南")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'aboutsite' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "使用规则", 8, _hoisted_6)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'renzheng' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "实名认证", 8, _hoisted_7)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'cooperation' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "合作协议", 8, _hoisted_8)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'privacyPolicy' },
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("li", {
              onClick: navigate,
              role: "link"
            }, "隐私政策", 8, _hoisted_9)
          ]),
          _: 1
        })
      ]),
      _hoisted_10
    ]),
    _createVNode(_component_html_footer)
  ]))
}